import fetch from 'isomorphic-fetch';
import cookie from 'react-cookie';
import { encryptId } from '../utils/userCrypto';
import config from '../config';
import newRelicNoticeError from '../utils/newRelic';

const JSON_MIME = 'application/json';

// eslint-disable-next-line prefer-template
export const createParamString = obj => Object.keys(obj)
  .filter(key => (obj[key] !== undefined && obj[key] !== null))
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
  .join('&');

const checkStatus = (res) => {
  if (res.status >= 200 && res.status < 300) return res;
  const error = new Error(res.statusText);
  error.response = res;
  error.statusCode = res.status;
  throw error;
};

const parseJSON = response => response.json();

export const doFetchWithOptions = (path, options) => {
  const at = cookie.load('access_token');
  if (at) { // todo remove
    path += `${path.indexOf('?') > -1 ? '&' : '?'}accesstoken=${at}`; // eslint-disable-line no-param-reassign
  }

  return fetch(`${config.bwHost}/proxy/${path}`, {
    ...options,
  })
    .then(checkStatus)
    .then(parseJSON);
};

const baseOptions = {
  method: 'GET',
  headers: {},
};

export const urlAppend = (path, queryParams) => {
  const firstChar = path.indexOf('?') > -1 ? '&' : '?';
  return `${path}${firstChar}${createParamString(queryParams)}`;
};

const doFetch = async (path, userDetails = null, options = baseOptions) => {
  const token = cookie.load('access_token');
  const legacyId = userDetails ? (userDetails.usID || userDetails.legacyId) : null;
  let fullPath = path;
  let authHeaders = {};

  if (token) {
    // eslint-disable-next-line no-param-reassign
    fullPath = urlAppend(path, {
      accesstoken: token,
    });
    authHeaders = {
      token,
      'custom-authorization': legacyId ? encryptId(legacyId) : '',
    };
  }

  try {
    return await fetch(`${config.bwHost}/proxy/${fullPath}`, {
      ...options,
      headers: {
        ...options.headers,
        ...authHeaders,
      },
    })
      .then(checkStatus)
      .then(parseJSON);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    newRelicNoticeError(error);
    throw error;
  }
};

const simpleFetch = async (url, options) =>
  parseJSON(checkStatus(await fetch(url, options)));

export const getJSON = async url =>
  simpleFetch(url, {
    headers: { accept: JSON_MIME },
  });

export const postJSON = async (url, body) =>
  simpleFetch(url, {
    method: 'POST',
    body: typeof body !== 'string' ? JSON.stringify(body) : body,
    headers: {
      accept: JSON_MIME,
      'Content-Type': JSON_MIME,
    },
  });

export default doFetch;



// WEBPACK FOOTER //
// ./src/common/baseFetch.js